import { useRef } from "react";
import styled from "styled-components";
import useIntersectionObserver from "../utils/useIntersectionObserver";
import { BREAK_POINT } from "../constants";

interface SectionTitleProps {
  children: React.ReactNode;
}

const SectionTitle = ({ children }: SectionTitleProps) => {
  const titleRef = useRef<HTMLDivElement>(null);

  useIntersectionObserver(
    titleRef,
    (entry) => {
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add("active");
      } else {
        entry.target.classList.remove("active");
      }
    },
    { threshold: [0, 0.5, 1] }
  );

  return (
    <Wrapper ref={titleRef}>
      <div>{children}</div>
    </Wrapper>
  );
};

export default SectionTitle;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 70px;
  font-size: 3rem;
  font-weight: 700;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 0%;
    height: 100%;
    min-width: 0;
    color: var(--white);
    background: linear-gradient(
      90deg,
      transparent 0%,
      var(--primary) 50%,
      transparent 100%
    );
  }

  &.active {
    > div {
      width: 33%;
      min-width: 240px;
      transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    height: 35px;
    font-size: 2.5rem;
  }
`;
